<template>
    <div class="c-text-between px-container c-flex-wrap">
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
        <span class="c-mb-10">释放你的全部潜能</span>
        <h1>你的资源中心</h1>
        <span class="c-mt-10 c-mb-10 c-text-left text-indent">
          欢迎访问我们的综合资源中心，我们旨在为使用 Franka Research 3 机器人平台的开发者和社区成员提供支持。无论您是想利用我们丰富的工具、库和文档来进行构建、创造和创新，还是想探索、加入并为我们充满活力的 Franka 社区做出贡献，您都能在这里找到所需的一切。
        </span>
      </div>
  
      <div class="display-width">
        <img src="@/assets/images/resources/app-tablet-image.d494a29.png" alt=""
          style="    height: auto; max-width: 100%;">
      </div>
    </div>
    
    <div id="resources-productdocumentation"></div>
    <div class="line-with-text px-container">
      <hr class="divider">
      <span class="line-text">产品文档</span>
      <hr class="divider">
    </div>
    <div class="c-text-between px-container c-flex-wrap"> 
      <div class="display-width">
        <img src="@/assets/images/resources/20220920_Franka_Research1771.jpg" alt=""
          style="    height: auto; max-width: 100%;">
      </div>
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
        <span class="c-mb-10">手册和其他支持材料</span>
        <h1>获取产品文档</h1>
        <span class="c-mt-10 c-mb-10 c-text-left ">
          探索Franka机器人产品的全面文档，包括产品手册，数据表，证书和安装指南。
        </span>
        <div class="c-text-justify-start c-flex-wrap c-mt-10 c-mb-10"> 
            <div class="buttonSite" style="width: 100px;"> 
              <a href="/#/documents" target="_self">探索</a>
            </div>
          </div>
      </div>
   
    </div> 
    <div id="resources-development"></div>
    <div class="line-with-text px-container">
      <hr class="divider">
      <span class="line-text">开发</span>
      <hr class="divider">
    </div>
    
    <div class="c-text-between px-container c-flex-wrap">
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
        <span class="c-mb-10" style="text-align: left;">建设，创造，革新</span>
        <h1>在Franka机器人平台上开发</h1>
        <span class="c-mt-10 c-mb-10 c-text-left text-indent">
          开发人员使用Franka Research 3机器人平台的资源中心。深入了解旨在加速您的开发旅程的大量工具、库和文档。
          无论你是一名经验丰富的开发者还是刚刚起步，你都能找到构建、创造和创新所需的一切。
        </span> 
        <div class="c-text-justify-start c-flex-wrap c-mt-10 c-mb-10"> 
          <div class="buttonSite" style="width: 100px;">
            <a href="/#/develop" target="_self">探索</a>
          </div>
        </div>
      </div>  
      <div class="display-width">
        <img src="@/assets/images/resources/_Franka Robotics _Franka AI Companion_20241723.jpg" alt=""
          style="    height: auto; max-width: 100%;">
      </div>
    </div>
 
    
    <div class="line-with-text px-container">
      <hr class="divider">
      <span class="line-text">社区贡献</span>
      <hr class="divider">
    </div>
    <div class="c-text-between px-container c-flex-wrap"> 
      <div class="display-width">
        <img src="@/assets/images/resources/_Frank Robotics0615_resized-1.jpg" alt=""
          style="    height: auto; max-width: 100%;">
      </div>
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
        <span class="c-mb-10" style="text-align: left;">探索 · 加入 · 共创</span>
        <h1>领略Franka社区的卓越贡献</h1>
        <span class="c-mt-10 c-mb-10 c-text-left text-indent">
          Franka社区以机器人技术与人工智能领域的创新协作精神闻名。这里汇聚了众多杰出成果，展现社区的非凡创造力！
        </span> 
        <div class="c-text-justify-start c-flex-wrap c-mt-10 c-mb-10"> 
          <div class="buttonSite" style="width: 100px;">
            <a href="/#/community" target="_self">探索</a>
          </div>
        </div>
      </div>  
    </div>
    
    <div id="resources-community"></div> 
    <div class="line-with-text px-container">
      <hr class="divider">
      <span class="line-text">加入我们的社区</span>
      <hr class="divider">
    </div>
    <div class="c-text-between px-container c-flex-wrap"> 
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;"> 
        <h1>欢迎来到 Franka 社区论坛</h1>
        <span class="c-mt-10 ">在这里和来自全球的Franka机械臂使用者互动</span>
        <span class="c-mt-10 c-mb-5 c-text-left text-indent">
          社区论坛提供了一个互动平台，专门为我们的机器人和产品服务。在这里，用户可以参与讨论、分享见解，并与其他也在使用 Franks Robotics 技术的同行建立联系。该论坛是一个宝贵的资源，帮助您探索具体应用、解决问题，并保持对我们机器人系统最新发展和创新的了解。
        </span> 
        <!-- <span class="c-mb-10 c-text-left ">
          立即注册，一起加入Franka社区吧！
        </span>  -->
        <div class="c-text-justify-start c-flex-wrap c-mt-10 c-mb-10"> 
          <!-- <div class="buttonSite  c-mr-20" style="width: 100px;">
            注册
          </div> -->
          <!-- <div class="buttonUndertone"  style="width: 100px;">
            登录
          </div> -->
        </div>
      </div>   
      <div class="display-width">
        <img src="@/assets/images/resources/image 55-2.png" alt=""
          style="    height: auto; max-width: 100%;">
      </div> 
    </div>

  </template>
  
  <script>
  // import HelloWorld from './components/HelloWorld.vue'
  
  export default {
    metaInfo() {
        return {
          title: this.$route.meta.title, // 从路由获取标题
          meta: [
            { 
              name: 'keywords', 
              content: this.$route.meta.metaTags[0]['content']
            }
          ]
        }
      },
    name: 'App',
    components: {
      // HelloWorld
    },
    data(){
      return {  
        
      }
    }, 
  }
  </script>
  
  <style scoped>
  
  .display-width{
    width: calc(50% - 40px);
  }
  
@media (max-width: 1029px) {
  }
  
  /* 屏幕宽度小于 900px 时，一行展示 2 个 */
  @media (max-width: 899px) {
    .display-width{
      width: 100%
    }
  }
  
  /* 屏幕宽度小于 600px 时，一行展示 1 个 */
  @media (max-width: 599px) {
  }
  
  </style>
  <style scoped> 
  /* h2 {
    font-size: 14px;
    margin-top: 10px;
    color: #333;
  } */
  </style>
  